var format = {
  methods: {
    emptyFormat(row, column, cell) {
      return cell ? cell : '- -'
    }
  }
}

export default format



// WEBPACK FOOTER //
// ./src/views/mixins/table-column-format.js